import { render, staticRenderFns } from "./ChatsRoom.vue?vue&type=template&id=40e8c506"
import script from "./ChatsRoom.vue?vue&type=script&lang=js"
export * from "./ChatsRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports